import React from 'react'

const CreateMaterialRecieptNote = () => {
  return (
    <div>CreateMaterialRecieptNote</div>
  )
}

export default CreateMaterialRecieptNote